import { useTranslation } from 'react-i18next';
import {
	FunctionaryInfo,
	UserRole,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { Button, Typography } from 'antd';
import { useCallback } from 'react';
import { useRedirectToLogin } from '../../../hooks/useRedirectToLogin';
import Icon from '../../../components/ui-components/Icon';
import RightArrowWhite from '../../../assets/images/arrow-right-white.svg';
import { useAddOrEditFunctionaryPage } from '../AddOrEditFunctionaryPage/useAddOrEditFunctionaryPage';
const { Text } = Typography;

interface FunctionaryCardProps extends FunctionaryInfo {
	onEditClick: (functionary: FunctionaryInfo) => void;
}

export const FunctionaryCard = (props: FunctionaryCardProps) => {
	const {
		printName,
		email,
		gender,
		mobile,
		srcmId,
		isApprover,
		isCareTeam,
		isZC,
		isPreworkAdmin,
		isScreeningAdmin,
		homeZone,
		onEditClick,
	} = props;
	const { t } = useTranslation();
	const { role } = useRedirectToLogin();
	const { addOrEditFormStatus } = useAddOrEditFunctionaryPage();

	const displayFunctionariesType = role === UserRole.ADMIN;

	const handleEditClick = useCallback(() => {
		addOrEditFormStatus();
		onEditClick(props);
	}, [onEditClick, props, addOrEditFormStatus]);

	const getFunctionaryType = useCallback(() => {
		if (isApprover) {
			return t('approver');
		} else if (isZC) {
			return t('zc');
		} else if (isCareTeam) {
			return t('careTeam');
		} else if (isPreworkAdmin) {
			return t('preworkAdmin');
		} else if (isScreeningAdmin) {
			return t('screeningAdmin');
		} else {
			return t('proposer');
		}
	}, [isApprover, isCareTeam, isZC, isPreworkAdmin, isScreeningAdmin, t]);

	return (
		<>
			<div className="flex flex-col rounded-lg border border-solid border-gray-300 bg-bground-blue p-[16px] py-[24px]">
				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('name')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{printName}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('email')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{email}</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('gender')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{gender &&
								gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()}
						</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('mobile')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{mobile}</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('SRCMID')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{srcmId}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('homeZone')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{homeZone}</Text>
					</div>
				</div>

				{displayFunctionariesType && (
					<div className="flex flex-row gap-6 mb-4">
						<div className="flex flex-col gap-1 w-[50%]">
							<Text className="text-light-gray text-sm">
								{t('functionaryType')}
							</Text>
							<Text className="text-gray-650 text-sm font-bold">
								{getFunctionaryType()}
							</Text>
						</div>
					</div>
				)}

				<div className="flex justify-center">
					<Button type="primary" onClick={handleEditClick} className="w-full">
						<span className="flex gap-2">
							{t('editOrUpdate')}
							<Icon src={RightArrowWhite} width="w-4" height="h-4" />
						</span>
					</Button>
				</div>
			</div>
		</>
	);
};
